import React from "react";
import "../../assets/logo/whatsapp.png";
import whatsappIcon from "../../assets/logo/whatsapp.png";

const FABContactUs = () => {
  return (
    <div className="fixed bottom-5 right-5 flex items-center gap-2 z-50 group">
      <div className="bg-green-500 text-white text-sm font-semibold py-2 px-4 rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-300">
        Contact Us Now!
      </div>

      {/* WhatsApp FAB */}
      <a
        href="https://wa.me/6281378569322?text=Halo%20saya%20ingin%20bertanya%20tentang%20wedify"
        target="_blank"
        rel="noopener noreferrer"
        className="w-14 h-14 bg-green-500 rounded-full flex items-center justify-center shadow-lg hover:scale-110 transition-transform duration-300"
      >
        <img src={whatsappIcon} alt="WhatsApp" className="w-8 h-8" />
      </a>
    </div>
  );
};

export default FABContactUs;
